<div class="full-width-container">
	<app-header [showLogout]="true" [showSignup]="false"></app-header>
	<mat-sidenav-container class="c4-sidenav-container">
		<mat-sidenav
			#sidenav
			*ngIf="!opened"
			[fixedBottomGap]="options.value.bottom"
			[fixedInViewport]="options.value.fixed"
			[fixedTopGap]="options.value.top"
			class="sidenavStyle"
			mode="side"
			opened="true"
		>
			<mat-nav-list *ngIf="utilService.isAccountTypeAdmin()" style="margin-bottom: 3rem">
				<div style="padding: 1rem">CUSTOMERS</div>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['/accounts', '/account_details'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/accounts"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">account_box</mat-icon>
					ACCOUNTS
				</a>

				<a
					*ngIf="userRoleService.CARRIER_RECRUITING_ADMIN"
					[ngClass]="utilService.isActiveClass(['/recruiters_report'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/recruiters_report"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">account_box</mat-icon>
					RECRUITER REPORTS
				</a>

				<a
					*ngIf="userRoleService.CARRIER_RECRUITER"
					[ngClass]="utilService.isActiveClass(['/my_accounts'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/my_accounts"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">account_box</mat-icon>
					MY ACCOUNTS
				</a>
				<a
					*ngIf="userRoleService.CARRIER_RECRUITER || userRoleService.CARRIER_RECRUITING_ADMIN"
					[ngClass]="utilService.isActiveClass(['/my_carriers'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/my_carriers"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">view_module</mat-icon>
					MY CARRIERS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['surveys'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/surveys"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">feedback</mat-icon>
					CUSTOMER SURVEYS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['plan_list', 'plan_list'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/plan_list"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">list_alt</mat-icon>
					PLANS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['products', 'products'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/products/list"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">list_alt</mat-icon>
					PRODUCTS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['add_on_products', 'add_on_products'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/add_on_products/list"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">list_alt</mat-icon>
					ADD ON PRODUCTS
				</a>
				<div style="padding: 1rem">CARRIERS</div>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['carrier_dashboard', 'carrier_profile'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/carrier_dashboard"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">view_module</mat-icon>
					CARRIERS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['lanes_dashboard', 'lane_carriers'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/lanes_dashboard"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">border_all</mat-icon>
					MANAGE LANES
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['mapper_carriers'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/mapped_carriers"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">border_all</mat-icon>
					MAPPED CARRIERS
				</a>
				<div style="padding: 1rem">SEARCHES</div>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['capacity'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/capacity"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">search</mat-icon>
					SEARCH CAPACITY
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['search_trucks_details'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/search_trucks_details"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">search</mat-icon>
					TRUCK SEARCHES
				</a>
				<a
					[ngClass]="
						utilService.isActiveClass(['truck_lanes_searches', 'truck_lane_search_details'], false)
					"
					class="menu-item"
					mat-list-item
					routerLink="/admin/truck_lanes_searches"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">search</mat-icon>
					LANE SEARCHES
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['booking_assistant_engagement'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/booking_assistant_engagement"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">assignment</mat-icon>
					BOOKING ASSISTANT ENGAGEMENT
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['dfm_stats'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/dfm_stats"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">query_stats</mat-icon>
					DFM STATS
				</a>
				<div style="padding: 1rem">PRICING</div>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['pricing_adjustments'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/pricing_adjustments"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">bar_chart</mat-icon>
					PRICING ADJUSTMENTS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['pricing_index'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/pricing_index"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">bar_chart</mat-icon>
					PRICING INDEXES
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['fuel_prices'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/fuel_prices"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">bar_chart</mat-icon>
					FUEL PRICES
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['pricing_feedback'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/pricing_feedback"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">feedback</mat-icon>
					PRICING FEEDBACK
				</a>
				<div style="padding: 1rem">CAPACITY</div>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['review_emails'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/review_emails"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">bar_chart</mat-icon>
					REVIEW EMAILS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['capacity_emails'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/capacity_emails"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">crop_square</mat-icon>
					CAPACITY EMAILS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['inbound_emails'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/inbound_emails"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">email</mat-icon>
					INBOUND EMAILS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['email_templates'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/users/email_templates"
					[queryParams]="{ templateType: TEMPLATE_TYPE.LOAD_OFFER }"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">edit</mat-icon>
					EMAIL TEMPLATES
				</a>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['analyze_trucks'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/analyze_trucks"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">local_shipping</mat-icon>
					ANALYZE TRUCKS
				</a>
				<a
					[ngClass]="utilService.isActiveClass(['analyze_lanes'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/analyze_lanes"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">bar_chart</mat-icon>
					ANALYZE LANES
				</a>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['oauth_dashboard', 'oauthclient_profile'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/oauth_dashboard"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">email</mat-icon>
					OAUTH CLIENTS
				</a>
				<mat-divider></mat-divider>
				<a
					[ngClass]="utilService.isActiveClass(['background_jobs'], false)"
					class="menu-item"
					mat-list-item
					routerLink="/admin/background_jobs"
					routerLinkActive="active"
				>
					<mat-icon class="primary-light-color m-r-1">hourglass_full</mat-icon>
					BACKGROUND JOBS
				</a>
			</mat-nav-list>
		</mat-sidenav>

		<mat-sidenav-content style="background-color: #edecec">
			<router-outlet></router-outlet>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>
